import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const OrgDashboardCheckoutAppLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "OrgDashboardCheckoutApp" */
      './OrgDashboardCheckoutApp.dynamic'
    ),
  loading: LoadingPageLoadable,
});
